import { atom } from "recoil";

export const settedFileAtom = atom<any>({
  key: "settedFileAtom",
  default: "",
});
